import {useDispatch} from 'react-redux';

import {CardWidgetBanner} from 'shells/card/card-widget-banner/card-widget-banner';
import {PersonSearchRegularAiIcon} from 'shells/icon';
import {Body} from 'shells/typography/body';

import type {McfxViqContactFragment} from 'nutshell-graphql-types';

import {analyticsClient} from '../../../../../analytics-client';
import {openSidebar} from '../../../../people-iq/redux/actions';

interface Props {
    accountId: string;
    accountName: string;
    contacts: McfxViqContactFragment[];
    onDismiss: () => void;
}

export function AccountPeopleIqBanner(props: Props) {
    const dispatch = useDispatch();
    // Fallback name to power the sidebar
    const accountName = props.accountName || 'this company';

    const onOpenSidebar = () => {
        analyticsClient.track(analyticsClient.EVENTS.TRACK_PIQ_SIDEBAR_ACCOUNT_OPENED);
        dispatch(
            openSidebar({
                accountId: props.accountId,
                accountName,
                leadId: null,
                contacts: props.contacts || [],
            })
        );
    };

    return (
        <>
            <CardWidgetBanner
                key='company-iq-visitors'
                title='People IQ'
                secondaryTitle={
                    <>
                        <Body isBold={true} size='small'>
                            {props.contacts.length} people found
                        </Body>{' '}
                        that might work at this company.
                    </>
                }
                titleIcon={PersonSearchRegularAiIcon}
                actionLabel='Review'
                onClick={onOpenSidebar}
                onDismiss={props.onDismiss}
                widgetType='NUTSHELL_IQ'
            />
        </>
    );
}
